import { useRouter } from "next/router";
import {
  CLASSROOM_DATA_REPORT,
  POWER_WORDS_REPORT,
  POWER_WORDS_STUDENT_REPORT,
  STUDENT_DATA_REPORT,
} from "../../constants";
import {
  sidebarTitleCss,
  listNavigationItemsContainerCss,
} from "./SidebarNavigationList.style";
import stripSlashesFromPath from "./utils/stripSlashesFromPath";
import SidebarNavigationItem from "./SidebarNavigationItem";

interface SidebarNavigationListProps {
  isStudentPage?: boolean;
}

export interface SidebarItem {
  name: string;
  id: string;
}

const SidebarNavigationList = ({
  isStudentPage = false,
}: SidebarNavigationListProps) => {
  const { pathname } = useRouter();
  const strippedPathname = stripSlashesFromPath(pathname);

  const isClassroomDataReportPage =
    strippedPathname === stripSlashesFromPath(CLASSROOM_DATA_REPORT.href);

  const isStudentDataReportPage =
    strippedPathname === stripSlashesFromPath(STUDENT_DATA_REPORT.href);

  const isClassroomDataNavigationItemActive =
    isClassroomDataReportPage || isStudentDataReportPage;

  const isPowerWordsClassroomReportPage =
    strippedPathname === stripSlashesFromPath(POWER_WORDS_REPORT.href);

  const isPowerWordsStudentReportPage =
    strippedPathname === stripSlashesFromPath(POWER_WORDS_STUDENT_REPORT.href);

  const isPowerWordsNavigationItemActive =
    isPowerWordsClassroomReportPage || isPowerWordsStudentReportPage;

  return (
    <>
      <h2 css={sidebarTitleCss}>Reports</h2>
      <ul css={listNavigationItemsContainerCss}>
        <SidebarNavigationItem
          name={CLASSROOM_DATA_REPORT.name}
          classroomPageBaseUrl={CLASSROOM_DATA_REPORT.href}
          studentPageBaseUrl={STUDENT_DATA_REPORT.href}
          streamProperties={{
            description: `Teacher Reporting - Sidebar ${isStudentPage ? "Student Data" : "Classroom Data"} link`,
          }}
          dataQaSelector="teacher-report-sidebar-classroom-data-link"
          isStudentPage={isStudentPage}
          isActive={isClassroomDataNavigationItemActive}
        />
        <SidebarNavigationItem
          name={POWER_WORDS_REPORT.name}
          classroomPageBaseUrl={POWER_WORDS_REPORT.href}
          studentPageBaseUrl={POWER_WORDS_STUDENT_REPORT.href}
          streamProperties={{
            description: `Teacher Reporting - Sidebar Power Words ${isStudentPage ? "student" : "classroom"} link`,
          }}
          dataQaSelector="teacher-report-sidebar-power-words-link"
          isStudentPage={isStudentPage}
          isActive={isPowerWordsNavigationItemActive}
        />
      </ul>
    </>
  );
};

export default SidebarNavigationList;
